export const toSizeName = (size: {width: number, height: number, length: number}) => [size.width, size.height, size.length].filter(value => value > 0).join(":");
